export enum ETypSouboru {
    SOUBOR_PLNAMOC = 'PLNAMOC',
    SOUBOR_JINASMLOUVA = 'JINASMLOUVA',
    SOUBOR_DOKLAD = 'DOKLAD',
    SOUBOR_PODEPSANYSOUBOR = 'PODEPSANYSOUBOR',
    SOUBOR_UCET = 'UCET'
}
